// The appearance pickers' copy.
//
// `THEME_PRESETS` and `FONT_SIZES` live in `@parsina/framework/tokens`, where
// they are DATA: an id, a swatch, a type scale. Each row also carries a `label`,
// and that label is Persian — the kit is installed by panels that ship Persian
// only, so that is the right default for it to hold.
//
// Rendering that label verbatim is what put «آبی پارسینا» and «کوچک» on the
// English settings screen. The ids are stable and the catalogue keys on them,
// so the fix is to look the name up here and fall back to whatever the kit
// supplied for a preset this app has no key for.
//
// Both surfaces use these, which is the point: the web and mobile forks must
// not be able to disagree about what an accent is called.

/**
 * @param {{t: Function, has: Function}} i18n  from `useTranslation()`
 * @param {Array<{id: string, label?: string}>} presets  kit rows
 */
export function localizedThemePresets({ t, has }, presets = []) {
  return presets.map((preset) => {
    const key = `settings.appearance.themes.${preset.id}`;
    return has(key) ? { ...preset, label: t(key) } : preset;
  });
}

export function localizedFontSizes({ t, has }, sizes = []) {
  return sizes.map((size) => {
    const key = `settings.appearance.fontSizes.${size.id}`;
    return has(key) ? { ...size, label: t(key) } : size;
  });
}
